import { fileToBase64, today } from "../../utils";
import { useAppContext } from "../../context/AppContext";
import { common_file_upload, serve_file } from "../../constants/apis";
import { toast } from "react-toastify";

import DocumentIcon from "../Icons/DocumentIcon";
import DragAndDrop from "../DragAndDrop";
import { useFieldArray, useFormContext } from "react-hook-form";
import { FullRegistrationFormType } from "../../schemas/XFlowFullRegSchema";

import InputWithLabel from "../InputWithLabel";
import CustomDropdown from "./CustomDropdown";
import { businessDetails } from "../../constants/variable";
import Dropdown from "../DropDown";
import Modal from "../Modal";
import { useRef, useState } from "react";
import { SpinnerIcon } from "../Icons";

const FouderDocumentSection = ({ nestIndex }: { nestIndex: number }) => {
  const [documentFileData, setDocumentFileData] = useState({
    fileUrl: "",
    mimeType: "",
    loading: false,
    error: "",
  });
  const viewDocumentDialogRef = useRef<HTMLDialogElement>(null);

  const {
    register,
    formState: { errors },
    control,
    setValue,
    getValues,
    clearErrors,
  } = useFormContext<FullRegistrationFormType>();

  const { jwtToken } = useAppContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: `founders.${nestIndex}.company_authorisation_documents_details`,
  });

  // console.log(fields);

  const toggleDialog = () => {
    if (viewDocumentDialogRef.current?.hasAttribute("open")) {
      viewDocumentDialogRef.current?.close();
      const imgEl = document.getElementById(`blob-data`) as HTMLImageElement;
      imgEl.src = "";
      setDocumentFileData((prev) => ({ ...prev, error: "" }));
    } else {
      viewDocumentDialogRef.current?.showModal();
    }
  };

  async function getBlobFileData(url: string, jwtToken: string) {
    setDocumentFileData((prev) => ({ ...prev, loading: true }));

    try {
      const res = await fetch(`${serve_file}?file=${url}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });

      const blob = await res.blob();

      const newUrl = URL.createObjectURL(blob);
      setDocumentFileData((prev) => ({
        ...prev,
        fileUrl: newUrl,
        mimeType: blob.type,
      }));
    } catch (error) {
      console.log(error);
      setDocumentFileData({
        fileUrl: "",
        mimeType: "",
        loading: false,
        error: "Something went wrong please try again!",
      });
    } finally {
      setDocumentFileData((prev) => ({ ...prev, loading: false }));
    }
  }

  const uplodaFile = async (file: File, index: number) => {
    try {
      const base64String = await fileToBase64(file);

      const res = await fetch(common_file_upload, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          Content_Type: "application/json",
        },
        body: JSON.stringify({
          base64File: base64String,
          folder_name: "user",
        }),
      });

      const data = await res.json();

      // console.log(data);

      if (data.status === "success") {
        // clearErrors(
        //   `founders.${nestIndex}.company_authorisation_documents_details.${index}.file`
        // );
        setValue(
          `founders.${nestIndex}.company_authorisation_documents_details.${index}.document_file_path`,
          data.url as string
        );

        clearErrors(
          `founders.${nestIndex}.company_authorisation_documents_details.${index}.document_file_path`
        );
        // toast.success(data.msg);
      } else {
        toast.error("File upload went wrong please try again");
      }
    } catch (error) {
      console.error("Error converting file to Base64:", error);
      // toast.error("File upload went wrong please try again");
    }
  };

  const handleFileChangeAndUpload = async (
    e: React.FormEvent<HTMLInputElement>,
    index: number
  ) => {
    const file = e.currentTarget.files?.[0];
    if (file) {
      await uplodaFile(file, index);
    }
  };

  const handleDropAndUpload = async (
    e: React.DragEvent<HTMLDivElement>,
    index: number
  ) => {
    e.preventDefault();
    const file = e.dataTransfer.files?.[0];

    if (file) {
      await uplodaFile(file, index);
    }
  };

  return (
    <div>
      <hr />

      {fields.map((item, idx) => (
        <div key={item.id} className="flex flex-col gap-3">
          <h3
            className={`text-[#344054] font-medium pt-1 ${
              idx !== 0 && "border-t"
            }`}
          >
            Document
          </h3>

          <div className="flex gap-6">
            <Dropdown
              label="Document Type"
              placeholder="Select a document type"
              options={[{ label: "PAN", value: "PAN" }]}
              error={
                errors.founders?.[nestIndex]
                  ?.company_authorisation_documents_details?.[idx]
                  ?.document_type?.message
              }
              {...register(
                `founders.${nestIndex}.company_authorisation_documents_details.${idx}.document_type`
              )}
            />

            <InputWithLabel
              label="Document Number"
              placeholder="Enter here"
              error={
                errors.founders?.[nestIndex]
                  ?.company_authorisation_documents_details?.[idx]
                  ?.document_number?.message
              }
              {...register(
                `founders.${nestIndex}.company_authorisation_documents_details.${idx}.document_number`
              )}
            />

            <InputWithLabel
              label={`Name on Document`}
              placeholder="Enter here"
              error={
                errors.founders?.[nestIndex]
                  ?.company_authorisation_documents_details?.[idx]
                  ?.name_on_document?.message
              }
              {...register(
                `founders.${nestIndex}.company_authorisation_documents_details.${idx}.name_on_document`
              )}
            />
          </div>

          <div className="relative my-4">
            <hr />
            <p className="absolute -top-3 left-1/2 bg-white px-1">Or</p>
          </div>

          <div>
            <label className="text-[#344054] text-sm font-medium">
              Person Authorization Document (PAN)
            </label>

            {getValues()?.founders[
              nestIndex
            ]?.company_authorisation_documents_details?.at(idx)
              ?.document_file_path &&
              getValues()?.founders[nestIndex]
                ?.company_authorisation_documents_details[idx]
                ?.document_file_path && (
                <button
                  type="button"
                  className="text-sm flex float-end items-center gap-1 text-custom-blue hover:underline"
                  // target="_blank"
                  // rel="noopener noreferrer" // Important for security
                  // href={
                  //   getValues()?.founders[nestIndex]
                  //     ?.company_authorisation_documents_details[idx]
                  //     ?.document_file_path
                  // }
                  onClick={() => {
                    toggleDialog();
                    getBlobFileData(
                      getValues()?.founders[
                        nestIndex
                      ]?.company_authorisation_documents_details?.at(idx)
                        ?.document_file_path!,
                      jwtToken!
                    );
                  }}
                >
                  <DocumentIcon className="size-[14px]" /> View your uploaded
                  document
                </button>
              )}

            <DragAndDrop
              id={`file-input-${nestIndex}-${idx}`}
              onChange={(e) => {
                handleFileChangeAndUpload(e, idx);

                toast.promise(handleFileChangeAndUpload(e, idx), {
                  pending: "File is uploading",
                  success: "File has been uploaded 👌",
                  error: "Rejected, please try again 🤯",
                });
              }}
              onDrop={(e) => {
                handleDropAndUpload(e, idx);

                toast.promise(handleDropAndUpload(e, idx), {
                  pending: "File is uploading",
                  success: "File has been uploaded 👌",
                  error: "Rejected, please try again 🤯",
                });
              }}
            />

            {/* Display file validation/error messages */}
            <small className="text-red-500 h-[10px] block ml-1">
              {
                // errors.founders?.[nestIndex]
                //   ?.company_authorisation_documents_details?.[idx]?.file
                //   ?.message ||
                errors.founders?.[nestIndex]
                  ?.company_authorisation_documents_details?.[idx]
                  ?.document_file_path?.message
              }
            </small>
          </div>

          <div className="mb-5">
            {idx !== 0 && (
              <button
                type="button"
                className="text-red-500 hover:underline"
                onClick={() => remove(idx)}
              >
                remove
              </button>
            )}
          </div>
        </div>
      ))}

      {/* <div>
        <button
          type="button"
          className="h-[44px] px-2 rounded-md bg-custom-blue-medium text-white font-medium"
          onClick={() => {
            append({
              document_type: "",
              document_number: "",
              issuance_country: "",
              expiry_date: "",
              document_file_path: "",
              // file: "",
            });
          }}
        >
          Add A New Document
        </button>
      </div> */}

      {/* document dialog */}
      <Modal
        ref={viewDocumentDialogRef}
        toggleDialog={toggleDialog}
        className="max-w-[600px] w-full p-8 rounded-md backdrop:bg-black/50"
      >
        <h3 className="text-xl mb-4">Document</h3>
        <div className="flex justify-center">
          {documentFileData.fileUrl &&
            documentFileData.mimeType.startsWith("image/") && (
              <img
                id={`blob-data`}
                src={documentFileData.fileUrl}
                className="h-[500px]"
              />
            )}
          {documentFileData.loading && (
            <SpinnerIcon className="size-8 text-gray-200 animate-spin fill-blue-600" />
          )}
          {documentFileData.error && (
            <p className="text-red-400">{documentFileData.error}</p>
          )}
        </div>

        {documentFileData.fileUrl &&
          documentFileData.mimeType === "application/pdf" && (
            <div className="h-[500px] flex justify-center">
              <iframe id={`blob-data`} src={documentFileData.fileUrl} />
            </div>
          )}
      </Modal>
    </div>
  );
};

export default FouderDocumentSection;
